"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const GlobalContext_1 = require("../../context/GlobalContext");
const PreferencesContext_1 = require("../../context/PreferencesContext");
const ScaleContext_1 = require("../../context/ScaleContext");
const Resizer_1 = __importDefault(require("../../elements/resizer/Resizer"));
const highlight_1 = require("../../highlight");
const useResizerStatus_1 = require("../../hooks/useResizerStatus");
const styles = {
    common: (0, react_1.css) `
    pointer-events: bounding-box;

    @-moz-document url-prefix("") {
      pointer-events: fill;
    }
  `,
    hover: (0, react_1.css) `
    .delete-button {
      visibility: hidden;
    }
  `,
    Highlighted: (0, react_1.css) `
    .range-area {
      height: 100%;
      fill: #ff6f0057;
    }

    .delete-button {
      visibility: visible;
      cursor: pointer;
    }
  `,
};
function AnalysisRange({ rangeData, columnKey, activeTab, }) {
    const highlight = (0, highlight_1.useHighlight)([columnKey], {
        type: 'MULTIPLE_ANALYSIS_ZONE',
        extra: { colKey: columnKey },
    });
    const { scaleX } = (0, ScaleContext_1.useScaleChecked)();
    const { dispatch } = (0, PreferencesContext_1.usePreferences)();
    const { viewerRef } = (0, GlobalContext_1.useGlobal)();
    const resizeEndHandler = (0, react_2.useCallback)((resized) => {
        const { x1, x2 } = resized;
        const start = scaleX().invert(x2);
        const end = scaleX().invert(x1);
        dispatch({
            type: 'ANALYZE_SPECTRA',
            payload: { start, end, columnKey, nucleus: activeTab },
        });
    }, [activeTab, columnKey, dispatch, scaleX]);
    const from = scaleX()(rangeData.from);
    const to = scaleX()(rangeData.to);
    const isResizeingActive = (0, useResizerStatus_1.useResizerStatus)('multipleSpectraAnalysis');
    return ((0, jsx_runtime_1.jsx)("g", { ...highlight.onHover, ...highlight.onHover, children: (0, jsx_runtime_1.jsx)(Resizer_1.default, { tag: "svg", onEnd: resizeEndHandler, initialPosition: { x2: from, x1: to }, parentElement: viewerRef, disabled: !isResizeingActive, children: ({ x1, x2 }, isActive) => ((0, jsx_runtime_1.jsxs)("g", { transform: `translate(0,25)`, css: [
                    styles.common,
                    highlight.isActive || isActive
                        ? styles.Highlighted
                        : styles.hover,
                ], children: [(0, jsx_runtime_1.jsx)("rect", { x: "0", width: x2 - x1, height: "6", className: "range-area", fill: "green" }), (0, jsx_runtime_1.jsx)("text", { textAnchor: "middle", x: (x2 - x1) / 2, y: "-5", fontSize: "12", fill: "red", fontWeight: "bolder", fillOpacity: highlight.isActive ? 1 : 0.6, children: columnKey })] })) }, `${columnKey}_${to}_${from}`) }));
}
exports.default = AnalysisRange;
